import { danger } from '../../../../../utils/brandColors';

export default () => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  cardActionsContainer: {
    textAlign: 'right',
    display: 'block',
    marginTop: '1rem',
  },
  actionIconButtonDelete: { color: danger.main },
  eventTemplateEditorTabs: { marginBottom: '1rem' },
  formSection: {
    marginBottom: '4rem',
    width: '100%',
  },
});
